/**
 * Form field options for the Crear Oferta form
 * Centralized to maintain consistency and facilitate updates
 */

export const HISTORIAL_CREDITICIO_OPTIONS = [
  { value: 'sin' as const, label: 'Sin historial' },
  { value: 'con' as const, label: 'Con historial' },
] as const;

export const TIPO_GRUPO_OPTIONS = [
  { value: 'mujeres' as const, label: 'Solo mujeres' },
  { value: 'mixto' as const, label: 'Mixto' },
] as const;

export const FINANCIERA_OPTIONS = [
  { value: 'compartamos', label: 'Compartamos' },
  { value: 'crediclub', label: 'Crédiclub' },
  { value: 'afirme', label: 'Afirme' },
  { value: 'otra', label: 'Otra' },
] as const;
